import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PermissionType } from 'app/enums/permission.enum';
import { AuthService } from 'app/services/auth.service';

@Component({
  selector: 'app-case-actions',
  templateUrl: './case-actions.component.html',
  styleUrls: ['./case-actions.component.scss']
})
export class CaseActionsComponent implements OnInit {

  @Input() id: number;
  @Input() statusId: number;
  @Input() workflowInstanceId: number;
  @Output() action: EventEmitter<any> = new EventEmitter();

  deleteButton:boolean;
  followUpTaskButton:boolean;
  disableReOpenCase: boolean ;

  constructor(
    authService: AuthService
  ) { 
    this.deleteButton = authService.userHasPermission(PermissionType.CaseDelete);
    this.followUpTaskButton = authService.userHasPermission(PermissionType.CaseFollowUpTaskAction);
    this.disableReOpenCase = authService.userHasPermission(PermissionType.DisableReOpenCase);
  }

  ngOnInit(): void {

    // console.log('disableReOpenCase:', this.disableReOpenCase);
     // console.log('followUpTaskButton:', this.followUpTaskButton);
      //    console.log('deleteButton:', this.deleteButton);
  //console.log('statusId:', this.statusId);
  }

  actionClick(action: string): void {
    this.action.emit({id: this.id, action, workflowInstanceId: this.workflowInstanceId});
  }

}